require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconDocumentCopy.tsx
var IconDocumentCopy_exports = {};
__export(IconDocumentCopy_exports, {
  default: () => IconDocumentCopy_default
});
module.exports = __toCommonJS(IconDocumentCopy_exports);

// src/assets/monochrome/documentCopy.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgDocumentCopy = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { d: "M10.7547 16.0352C11.7548 16.034 12.7135 15.6362 13.4207 14.9291C14.1278 14.2219 14.5256 13.2632 14.5268 12.2631V5.65665C14.528 5.26009 14.4504 4.86725 14.2987 4.50089C14.1469 4.13452 13.9239 3.80193 13.6426 3.52239L11.9512 1.83097C11.6717 1.5497 11.3391 1.32672 10.9727 1.17494C10.6063 1.02317 10.2135 0.945617 9.81695 0.94679H6.22816C5.22811 0.947988 4.26935 1.34579 3.5622 2.05294C2.85505 2.76009 2.45725 3.71884 2.45605 4.7189V12.2631C2.45725 13.2632 2.85505 14.2219 3.5622 14.9291C4.26935 15.6362 5.22811 16.034 6.22816 16.0352H10.7547ZM3.9649 12.2631V4.7189C3.9649 4.11865 4.20335 3.54297 4.62779 3.11853C5.05224 2.69409 5.62791 2.45563 6.22816 2.45563C6.22816 2.45563 9.93917 2.4662 10.0003 2.47374V3.96448C10.0003 4.36465 10.1592 4.74843 10.4422 5.03139C10.7252 5.31436 11.1089 5.47332 11.5091 5.47332H12.9999C13.0074 5.53443 13.018 12.2631 13.018 12.2631C13.018 12.8634 12.7795 13.439 12.3551 13.8635C11.9306 14.2879 11.355 14.5264 10.7547 14.5264H6.22816C5.62791 14.5264 5.05224 14.2879 4.62779 13.8635C4.20335 13.439 3.9649 12.8634 3.9649 12.2631ZM17.5445 6.98217V15.2808C17.5433 16.2809 17.1455 17.2396 16.4383 17.9468C15.7312 18.6539 14.7724 19.0517 13.7724 19.0529H6.98259C6.7825 19.0529 6.59061 18.9734 6.44913 18.832C6.30765 18.6905 6.22816 18.4986 6.22816 18.2985C6.22816 18.0984 6.30765 17.9065 6.44913 17.765C6.59061 17.6236 6.7825 17.5441 6.98259 17.5441H13.7724C14.3726 17.5441 14.9483 17.3056 15.3728 16.8812C15.7972 16.4567 16.0357 15.8811 16.0357 15.2808V6.98217C16.0357 6.78208 16.1151 6.59019 16.2566 6.44871C16.3981 6.30723 16.59 6.22774 16.7901 6.22774C16.9902 6.22774 17.182 6.30723 17.3235 6.44871C17.465 6.59019 17.5445 6.78208 17.5445 6.98217Z", fill: "#676F7E" }) });
var documentCopy_default = SvgDocumentCopy;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconDocumentCopy.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconDocumentCopy = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(documentCopy_default, {}) });
};
IconDocumentCopy.displayName = "IconDocumentCopy";
var IconDocumentCopy_default = IconDocumentCopy;
